<mat-dialog-title
    class="emergency-modal-title-section"
    align="center"
    mat-dialog-title
    ><span role="heading" translate> contact.need</span>
    <a mat-dialog-close tabindex="0" class="close-modal" aria-label="Close">
        <img src="../../../assets/img/icons-svg/close-icon.svg" />
    </a>
</mat-dialog-title>
<mat-dialog-content class="emergency-modal-content">
    <p [innerHTML]="contactDescription"></p>
</mat-dialog-content>
<mat-dialog-actions
    *ngIf="!isHotline"
    class="emergency-modal-button-section"
    [ngClass]="{
        'multiple-cards': contactGroupTelephone && contactGroupTextMsgNumber,
    }"
    align="center">
    <button
        *ngIf="contactGroupTelephone"
        class="emergency-btn"
        (click)="callOrMsgEmergencyConatct('call', contactGroupTelephone)">
        <img src="../../../assets/img/icons-svg/emergency-calling.svg" />
        <span translate>contact.popupCallbtn</span>
    </button>
    <button
        *ngIf="contactGroupTextMsgNumber"
        class="emergency-btn"
        (click)="
            isSmsSupported
                ? callOrMsgEmergencyConatct('msg', contactGroupTextMsgNumber)
                : numberCopied(contactGroupTextMsgNumber)
        ">
        <img src="../../../assets/img/icons-svg/emergency-message.svg" />
        <span translate>contact.popupMessagebtn</span>
    </button>
    <button
        *ngIf="contactGroupTelephone"
        class="number-only-btn"
        (click)="numberCopied(contactGroupTelephone)">
        <span translate>{{ contactGroupTelephone }}</span>
        <img src="../../../assets/img/icons-svg/copy.svg" />
    </button>
    <button
        *ngIf="contactGroupTextMsgNumber"
        class="number-only-btn"
        (click)="numberCopied(contactGroupTextMsgNumber)">
        <span translate>{{ contactGroupTextMsgNumber }}</span>
        <img src="../../../assets/img/icons-svg/copy.svg" />
    </button>
</mat-dialog-actions>
<mat-dialog-actions *ngIf="isHotline" align="center">
    <mat-spinner
        class="spinner-class"
        *ngIf="!hotline"
        [diameter]="25"></mat-spinner>
    <div class="emergency-modal-button-section hotline-cards" *ngIf="hotline">
        <button
            class="emergency-btn"
            [ngClass]="{ 'full-width-btn': !isSmsSupported }"
            (click)="callOrMsgEmergencyConatct('call', hotline?.telephone)"
            mat-dialog-close>
            <img src="../../../assets/img/icons-svg/emergency-calling.svg" />
            <span translate>contact.popupCallbtn</span>
        </button>
        <button
            *ngIf="isSmsSupported"
            class="emergency-btn"
            (click)="callOrMsgEmergencyConatct('msg', hotline?.telephone)"
            mat-dialog-close>
            <img src="../../../assets/img/icons-svg/emergency-message.svg" />
            <span translate>contact.popupMessagebtn</span>
        </button>
        <button
            class="number-only-btn single-row"
            (click)="numberCopied(hotline?.telephone)">
            <span translate>{{ hotline?.telephone }}</span>
            <img src="../../../assets/img/icons-svg/copy.svg" />
        </button>
    </div>
</mat-dialog-actions>
